requestAnimationFrame(() => {
  scriptController.executeWhenScriptLoaded(['modal-dialog.js'], () => {
    scriptController.onStyleReady(() => {
      function throttle(func, delay) {
        let lastCall = 0;

        return function(...args) {
          const now = Date.now();
          if (now - lastCall >= delay) {
            lastCall = now;
            func.apply(this, args);
          }
        };
      }

      if (!customElements.get('cart-drawer')) {
        class CartDrawer extends ModalDialog {
          constructor() {
            super();

            this.addEventListener('modalOpened', () => {
              onTransitionEnd(this, () => {
                if (this.hasAttribute('open') && !this.contains(document.activeElement)) {
                  this.getKeyboardTargets()[0]?.focus({ preventScroll: true });
                }
              });
            });
            this.addEventListener('modalClosed', () => {
              if (this.focusReturnTarget?.isConnected) {
                this.focusReturnTarget.focus({ preventScroll: true });
              }
              this.focusReturnTarget = null;
            });
            this.addEventListener('keydown', (event) => {
              if (event.key !== 'Tab' || !this.hasAttribute('open')) return;
              const targets = this.getKeyboardTargets();
              const first = targets[0];
              const last = targets[targets.length - 1];
              if (!first) return;
              if (event.shiftKey && document.activeElement === first) {
                event.preventDefault();
                last.focus();
              } else if (!event.shiftKey && document.activeElement === last) {
                event.preventDefault();
                first.focus();
              }
            });

            this.throttledCheckFooter = throttle(this.updateFooterState.bind(this), 400);
            scriptController.scripts.push('cart-drawer.js');
          }

          connectedCallback() {
            if (!this.cartUpdateUnsubscribe && window.addToCartAction === 'cart_drawer' && !window.location.pathname.includes('/cart')) {
              this.cartUpdateUnsubscribe = subscribe(PUB_SUB_EVENTS.cartUpdateFinish, this.show.bind(this));
            }
          }

          disconnectedCallback() {
            this.cartUpdateUnsubscribe?.();
            this.cartUpdateUnsubscribe = null;
            this.stopFooterUpdates();
          }

          getKeyboardTargets() {
            return getFocusableElements(this).filter(element =>
              element.tabIndex >= 0 &&
              element.getClientRects().length &&
              getComputedStyle(element).visibility !== 'hidden'
            );
          }

          show() {
            if (!this.isConnected) return;
            if (!this.hasAttribute('open') && !this.contains(document.activeElement)) {
              this.focusReturnTarget = document.activeElement;
            }
            super.show(...arguments);

            if (Shopify.designMode) return;

            this.startFooterUpdates();
          }

          startFooterUpdates() {
            this.stopFooterUpdates();
            this.footerUpdatesActive = true;
            const update = () => {
              if (!this.footerUpdatesActive || !this.isConnected) {
                this.stopFooterUpdates();
                return;
              }
              this.throttledCheckFooter();
              this.animationId = requestAnimationFrame(update);
            };
            this.animationId = requestAnimationFrame(update);
          }

          stopFooterUpdates() {
            this.footerUpdatesActive = false;
            cancelAnimationFrame(this.animationId);
            this.animationId = null;
          }

          updateFooterState() {
            this.footer = this.querySelector('.cart-drawer__footer');
            this.itemsWrapper = this.querySelector('.cart-drawer__items');
            if (!this.footer || !this.itemsWrapper) return;
            this.items = this.itemsWrapper.querySelectorAll('.cart-drawer-item');
            this.recommendations = this.itemsWrapper.querySelector('.cart-drawer__recommendations-slot');
            this.notesDropdown = this.footer.querySelector('.animated-dropdown__dropdown');
            let footerHeight = this.footer.offsetHeight;

            if (this.notesDropdown) {
              footerHeight -= this.notesDropdown.offsetHeight;
            }

            let itemsBottomLimit = this.itemsWrapper.offsetTop + footerHeight;

            this.items.forEach((element, index) => {
              if (index >= 2) return false;
              itemsBottomLimit = itemsBottomLimit + (index === 0 ? element.offsetHeight : element.offsetHeight / 2);
            });

            if (this.recommendations?.offsetHeight) {
              itemsBottomLimit += this.recommendations.offsetHeight;
            }

            this.footer.classList[
              themeBase.windowHeight < itemsBottomLimit ? 'add' : 'remove'
            ]('cart-drawer__footer--static');
          }

          hide(callback) {
            this.stopFooterUpdates();
            super.hide(callback);
          }
        }

        customElements.define('cart-drawer', CartDrawer);
      }
    }, ['component-cart-drawer']);
  });
});
